import React from 'react';
import {MasterLayout} from 'layout';
import {DanhSachKeHoachThanhTraDaPheDuyet} from 'modules/thanh-tra';

export default class DanhSachThanhTraDaPheDuyetPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachKeHoachThanhTraDaPheDuyet/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/DanhSachThanhTraDaPheDuyetPage.jsx